<ng-container>
    <mat-toolbar>
        <div class="toTheRight">{{ 'pages.projektverwaltung.title' | translate }}</div>
      <app-projekt-filter
        class="filter"
        #projektFilter
      ></app-projekt-filter>

  <div class="add-button-container">
    <button matTooltip="Projekt Hinzufügen" *ngIf="(showAdd | async)" mat-mini-fab color="primary" aria-label="Add a address" class="pluscolor" (click)="addProjekt()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
    </mat-toolbar>
</ng-container>
<div class="page-content">
  <app-expandable-projekt-table
  [projekte]="$nodes | async"
  (deleteProjekt)="deleteProjekt($event); projektFilter.search(false);"
  (archiveProjekt)="archiveProjekt($event); projektFilter.search(false);"
  (dearchiveProjekt)="dearchiveProjekt($event); projektFilter.search(true);"
  (editProjekt)="editProjekt($event);"
  (editProjektstufe)="editProjektstufe($event);"
  (addProjektstufe)="addProjektstufe($event);"
  [copyNodes]="$copyNodes | async"
  ></app-expandable-projekt-table>
</div>

